export const ROLES = {
  SYSTEM_ADMIN: 'system-admin',
  INSTITUTION_ADMIN: 'institution-admin',
  UNI_ADMIN: 'uni-admin',
  RESEARCHER: 'researcher',
} as const

export const ROLE_LABELS: Record<string, string> = {
  'system-admin': 'System Administrator',
  'institution-admin': 'Institution Administrator',
  'uni-admin': 'University Administrator',
  'researcher': 'Researcher',
}

export const ADMIN_ROLES = [ROLES.SYSTEM_ADMIN, ROLES.INSTITUTION_ADMIN, ROLES.UNI_ADMIN] as const
